import React from 'react';
import PropTypes from 'prop-types';
import { Route, Redirect } from 'react-router-dom';
import { routes } from '../assets/routes';
import { get_now, get_token, get_user_info } from './api';

const PrivateRoute = (props) => {
  const { component: Component } = props;
  const renderRoute = (props) => {
    if (get_token() && get_user_info().exp > get_now()) {
      return props.match.params?.id ? (
        <Component key={props.match.params.id} {...props} />
      ) : (
        <Component {...props} />
      );
    } else {
      return <Redirect to={routes.LOGIN} />;
    }
  };

  return <Route path={props.path} render={renderRoute} exact={props.exact} />;
};

PrivateRoute.propTypes = {
  path: PropTypes.string,
  component: PropTypes.any,
  exact: PropTypes.bool,
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.number
    })
  })
};

export default PrivateRoute;
